<template>
  <div>
    <b-modal
      id="file-upload-modal"
      centered
      :title="$t('userManagement.document')"
      :ok-title="$t('references.upload')"
      :cancel-title="$t('userManagement.cancel')"
      @ok="onOk"
    >
      <b-form-file
        id="file"
        v-model="file"
        :placeholder="$t('userManagement.document')"
        accept=".xlsx"
        drop-placeholder="Drop file here..."
      />
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { BModal, BFormFile } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BFormFile,
  },
  data() {
    return {
      file: null,
    }
  },
  methods: {
    ...mapActions('finance', ['UPLOAD_FILE']),

    onOk() {
      const formData = new FormData()
      formData.append('file', this.file)
      console.log(formData)
      this.UPLOAD_FILE(formData).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
  },
}
</script>
